import './polyfill';
import React from 'react';

import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';
import * as Sentry from '@sentry/browser';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';

import App from './App';
import * as serviceWorker from './serviceWorker';

// import {whyDidYouUpdate} from 'why-did-you-update';

Sentry.init({
  enabled: process.env.REACT_APP_SENTRY_ENABLED === '1',
  dsn: process.env.REACT_APP_SENTRY_DSN,
  debug: process.env.REACT_APP_ENV === 'prod' ? 'false' : true,
  environment: process.env.REACT_APP_ENV,
});

if (process.env.NODE_ENV === 'production') {
  const tagManagerArgs = {
    gtmId: 'GTM-WM4CSP2',
  };
  TagManager.initialize(tagManagerArgs);
  console.log('GTM Initialized');
}

const instance = createInstance({
  urlBase: 'https://dtdigit.matomo.cloud/',
  siteId: process.env.REACT_APP_MATOMO_SITEID,
  disabled: false,
  heartBeat: {
    active: true,
    seconds: 10,
  },
  linkTracking: false,
  configurations: {
    disableCookies: true,
    setSecureCookie: true,
    setRequestMethod: 'GET',
  },
});

// if (process.env.NODE_ENV !== 'production') {
// Why-did-you-update is a function that monkey patches React
// and notifies you in the console when potentially unnecessary re-renders occur.
// whyDidYouUpdate(React);
// }

ReactDOM.render(
  <MatomoProvider value={instance}>
    <App />
  </MatomoProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
